import { TStudentAttendanceRecord } from '../../../apis/students/studentDetails/studentDetails.interfaces';
import { ATTENDANCE_STATUS } from '../../../apis/__shared/attendance.interfaces';

export const mockStudentDetailsAttendance: TStudentAttendanceRecord[] = [
  { date: '2024-01-15', status: ATTENDANCE_STATUS.PRESENT, period: 'Full Day' },
  { date: '2024-01-16', status: ATTENDANCE_STATUS.PRESENT, period: 'Full Day' },
  { date: '2024-01-17', status: ATTENDANCE_STATUS.ABSENT, period: 'Full Day' },
  { date: '2024-01-18', status: ATTENDANCE_STATUS.PRESENT, period: 'Full Day' },
  { date: '2024-01-19', status: ATTENDANCE_STATUS.LATE, period: 'Full Day' },
  { date: '2024-01-22', status: ATTENDANCE_STATUS.PRESENT, period: 'Full Day' },
  { date: '2024-01-23', status: ATTENDANCE_STATUS.PRESENT, period: 'Full Day' },
  { date: '2024-01-24', status: ATTENDANCE_STATUS.PRESENT, period: 'Full Day' },
  { date: '2024-01-25', status: ATTENDANCE_STATUS.ABSENT, period: 'Full Day' },
  { date: '2024-01-26', status: ATTENDANCE_STATUS.PRESENT, period: 'Full Day' },
  { date: '2024-01-29', status: ATTENDANCE_STATUS.PRESENT, period: 'Full Day' },
  { date: '2024-01-30', status: ATTENDANCE_STATUS.PRESENT, period: 'Full Day' },
  { date: '2024-01-31', status: ATTENDANCE_STATUS.LATE, period: 'Full Day' },
  { date: '2024-02-01', status: ATTENDANCE_STATUS.PRESENT, period: 'Full Day' },
  { date: '2024-02-02', status: ATTENDANCE_STATUS.PRESENT, period: 'Full Day' },
];
